
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-luxury-navy text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-8">
              <img 
                src="https://static.readdy.ai/image/18ddd3c5386ce7455627992c42f8b0cb/f4e0fe60f5ceffe9412c875da26f8438.jpeg" 
                alt="Garage de carcare ロゴ" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 mb-8 leading-relaxed text-sm font-light">
              岐阜県美濃加茂市の洗車コーティング専門店。「安く、綺麗に」をモットーに、自宅ガレージで職人レベルの丁寧な施工を提供しています。土日限定・完全予約制で、お客様一人ひとりに集中したサービスをお届けします。
            </p>
            <div className="mb-8">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/service-select')}
                className="bg-luxury-navy border border-white/20 text-white px-7 py-3 rounded-md text-sm font-medium hover:bg-white hover:text-luxury-navy transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calculator-line mr-2"></i>
                料金シミュレーション
              </button>
            </div>
            <div className="flex space-x-4">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/line')}
                className="w-10 h-10 bg-luxury-navy border border-white/20 rounded-full flex items-center justify-center hover:bg-white hover:text-luxury-navy transition-all cursor-pointer"
              >
                <i className="ri-message-line"></i>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-medium mb-6 tracking-tight">クイックリンク</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-luxury-blue transition-colors cursor-pointer text-sm font-light"
                >
                  ホーム
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-luxury-blue transition-colors cursor-pointer text-sm font-light"
                >
                  概要
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-luxury-blue transition-colors cursor-pointer text-sm font-light"
                >
                  サービス・料金
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-400 hover:text-luxury-blue transition-colors cursor-pointer text-sm font-light"
                >
                  施工実績
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('booking')}
                  className="text-gray-400 hover:text-luxury-blue transition-colors cursor-pointer text-sm font-light"
                >
                  予約・お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base font-medium mb-6 tracking-tight">営業情報</h4>
            <div className="space-y-5">
              <div>
                <h5 className="font-medium text-luxury-blue mb-2 text-sm">営業時間</h5>
                <p className="text-gray-400 text-sm font-light">土曜日・日曜日</p>
                <p className="text-gray-400 text-sm font-light">9:00 - 18:00</p>
                <p className="text-red-400 text-sm font-light">平日定休</p>
              </div>
              <div>
                <h5 className="font-medium text-luxury-blue mb-2 text-sm">所在地</h5>
                <p className="text-gray-400 text-sm font-light">岐阜県美濃加茂市内</p>
                <p className="text-gray-400 text-sm font-light">自宅ガレージにて施工</p>
              </div>
              <div>
                <h5 className="font-medium text-luxury-blue mb-2 text-sm">予約制</h5>
                <p className="text-gray-400 text-sm font-light">完全予約制</p>
                <p className="text-gray-400 text-sm font-light">事前予約必須</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-xs mb-4 md:mb-0 font-light">
              © 2024 Garage de carcare. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="nofollow"
                className="text-gray-500 hover:text-luxury-blue text-xs transition-colors font-light"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
